/* ------------ widget imports ------------ */
import type {ReactElement} from 'react';
import OrdersStatsWidget from './OrderStatsWidget/OrdersStatsWidget';
import OrdersCountWidget from './OrderCountWidget/OrdersCountWidget';
import FundingOverviewWidget from './FundingOverviewWidget/FundingOverviewWidget';
import FarmersOverviewWidget from './FarmersOverviewWidget/FarmersOverviewWidget';
import FarmRisksWidget from './FarmRisksWidget/FarmRisksWidget';
import FundingPerProvinceWidget from './FundingPerProvinceWidget/FundingPerProvinceWidget';
import FundingPerCropWidget from './FundingPerCropWidget/FundingPerCropWidget';
import RecentApplicationChangesWidget from './RecentApplicationChangesWidget/RecentApplicationChangesWidget';
import WalletMetricsWidget from './WalletMetricsWidget/WalletMetricsWidget';
import ProgramSummaryWidget from './ProgramSummaryWidget/ProgramSummaryWidget';
import OrderSummaryWidget from './OrderSummaryWidget/OrderSummaryWidget';
import QuoteSummaryWidget from './QuoteSummaryWidget/QuoteSummaryWidget';
import FavouriteProductsWidget from './FavouriteProductsWidget/FavouriteProductsWidget';
import DataCapturingFeedWidget from './DataCapturingFeedWidget/DataCapturingFeedWidget';
import InputFunnelNumberWidget from './InputFunnelNumberWidget/InputFunnelNumberWidget';
import InputFunnelRandsWidget from './InputFunnelRandsWidget/InputFunnelRandsWidget';
import ProductViewsWidget from './ProductViewsWidget/ProductViewsWidget';
import StoreViewsWidget from './StoreViewsWidget/StoreViewsWidget';
import TopInputProductsWidget from './TopInputProductsWidget/TopInputProductsWidget';
import {ISupplierUserProfile} from 'constants/interfaces';

/* -----------------------------------------------------------------------------
   CENTRAL registry ► every widget component must appear here.
----------------------------------------------------------------------------- */
export const widgetComponentMap = {
  ordersStats: OrdersStatsWidget,
  ordersCount: OrdersCountWidget,
  fundingOverview: FundingOverviewWidget,
  farmersOverview: FarmersOverviewWidget,

  /* new */
  satelliteRisks: FarmRisksWidget,
  walletMetrics: WalletMetricsWidget,
  programsOverview: ProgramSummaryWidget,
  orderSummary: OrderSummaryWidget,
  quoteSummary: QuoteSummaryWidget,
  favouriteProducts: FavouriteProductsWidget,
  dataCapturingFeed: DataCapturingFeedWidget,
  fundingPerProvince: FundingPerProvinceWidget,
  fundingPerCrop: FundingPerCropWidget,
  recentApplicationChanges: RecentApplicationChangesWidget,
  inputFunnelNumber: InputFunnelNumberWidget,
  inputFunnelRands: InputFunnelRandsWidget,
  productViews: ProductViewsWidget,
  storeViews: StoreViewsWidget,
  topInputProducts: TopInputProductsWidget,
} as const satisfies Record<string, () => ReactElement>;

/*  WdgId is now ALWAYS in-sync with the keys of widgetComponentMap */
export type WdgId = keyof typeof widgetComponentMap;

const supplierAnalyticsWidgetIds = new Set<WdgId>([
  'productViews',
  'storeViews',
  'topInputProducts',
]);

export function shouldShowOverviewWidget(
  widgetId: WdgId,
  user?: ISupplierUserProfile,
) {
  if (!supplierAnalyticsWidgetIds.has(widgetId)) return true;

  const companyType = String(
    (user as any)?.company?.companyType?.name ||
      (user as any)?.companyType?.name ||
      '',
  ).toLowerCase();
  const isEnterpriseGroup =
    Boolean((user as any)?.isEnterpriseGroup) ||
    companyType.includes('enterprise');

  return (
    !user?.isCommodityGroup && !isEnterpriseGroup && Boolean(user?.brand?.id)
  );
}
